import { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import { setTabOnFocus, toggleRightDrawer } from '../../store/global/actions';
import { marginBottomForBreadCrumb } from '../../config/styles';
import { useDispatch } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import Divider from '@material-ui/core/Divider';
import { Grid } from '@material-ui/core';
import ChildTransactionConfiguration from '../molecules/simulations/ChildTransactionConfiguration';


export default function ChildSimulationTransaction({ element }) {
    const dispatch = useDispatch();
    const [openTab, setOpenTab] = useState(0);
    const detailsBC = [
        { label: 'Simulation', url: null },
        { label: element.name, url: null }
    ];


    const onClose = () => {
        dispatch(toggleRightDrawer());
    }


    return (
        <>
            <AppBar position="static">
                <Tabs value={openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }} aria-label="SimulationTransactionTabs">
                    <Tab label="Configuration" />
                </Tabs>
            </AppBar>


            <TabPanel value={openTab} index={0} >
                <Grid container direction={"row"} spacing={2}>
                    <Grid item xs={8}>
                        <BreadCrumb items={detailsBC} />
                    </Grid>
                </Grid>

                <Divider style={marginBottomForBreadCrumb} />

                <ChildTransactionConfiguration testcase_name={element.testcase_name} simulationTransactionId={element.simulation_transaction_id} onClose={onClose} testCaseId={element.testcase_id} conditionFlag={element.conditionFlag} loopFlag={element.loopFlag} />
            </TabPanel>
        </>
    )


}